
import {Tabs} from 'vant'

const TabsPatched = {
    extends: Tabs,
    methods: {
        // scroll active tab into view
        scrollIntoView: function scrollIntoView(immediate) {
            var titles = this.$refs.titles;

            if (!this.scrollable || !titles || !titles[this.currentIndex]) {
                return;
            }

            var nav = this.$refs.nav;
            var title = titles[this.currentIndex].$el;
            var to = title.offsetLeft - (nav.offsetWidth - title.offsetWidth) / 2;

            // 注释原来的scrollLeftTo方法，直接设置容器的scrollLeft将当前选中的标签滚动至居中位置
            // (0, _utils2.scrollLeftTo)(nav, to, immediate ? 0 : +this.duration);

            setTimeout(_ => {
                nav.scrollLeft += to - nav.scrollLeft
            }, immediate ? 0 : this.duration * 1000)
        },
    }
}

export default {
    install(Vue) {
        Vue.component(Tabs.name, TabsPatched)
    }
}


// WEBPACK FOOTER //
// ./src/components/patches/van-tabs.js